var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h5',[_vm._v("Page introuvable")])])
}
var staticRenderFns = []

export { render, staticRenderFns }